import React from "react";
import BadgeGenerator from "./components/BadgeGenerator";
import "./styles/App.css";

const App = () => {

  return <BadgeGenerator  />;
};

export default App;